import * as React from "react";
import { Component } from "react";
import { Button, Col, ControlLabel, Form, FormControl, FormGroup } from "react-bootstrap";
import LoadingStatus from "src/components/common/LoadingStatus";
import "../../../../css/components/projects/project/accounts/accountform.css";
import { IAccountProps, IAccountState } from "./interfaces";

export default class AccountForm extends Component<IAccountProps, IAccountState> {
  public constructor(props: IAccountProps) {
    super(props);

    this.state = { loading: true };

    this.handleAccountHolderChanged = this.handleAccountHolderChanged.bind(this);
    this.handleAccountNumberChanged = this.handleAccountNumberChanged.bind(this);
    this.handleAddressChanged = this.handleAddressChanged.bind(this);
    this.handleCityStateChanged = this.handleCityStateChanged.bind(this);
    this.handleNameKeyChanged = this.handleNameKeyChanged.bind(this);
    this.handleServiceReferenceChanged = this.handleServiceReferenceChanged.bind(this);

    this.handleSave = this.handleSave.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  public componentDidMount() {
    this.setState({ loading: false });
  }

  public render() {
    if (this.state.loading) {
      return <LoadingStatus text="Loading..." />;
    }

    const labelWidth = 4;
    const inputWidth = 8;

    return (
      <div className="column container-fixed-navbar account-Form-Grid">
        <div className="account-Form">
          <fieldset id="accountInformation">
            <legend>Account Information</legend>
            <Form onSubmit={this.handleSave} horizontal={true}>
              <FormGroup controlId="accountHolder">
                <Col componentClass={ControlLabel} sm={labelWidth}>
                  Account Holder
                </Col>
                <Col sm={inputWidth}>
                  <FormControl
                    type="text"
                    value={this.props.accountHolder}
                    onChange={this.handleAccountHolderChanged}
                  />
                </Col>
              </FormGroup>
              <FormGroup controlId="nameKey">
                <Col componentClass={ControlLabel} sm={labelWidth}>
                  Name Key
                </Col>
                <Col sm={inputWidth}>
                  <FormControl
                    type="text"
                    value={this.props.nameKey}
                    onChange={this.handleNameKeyChanged}
                  />
                </Col>
              </FormGroup>
              <FormGroup controlId="serviceReference">
                <Col componentClass={ControlLabel} sm={labelWidth}>
                  Service Reference
                </Col>
                <Col sm={inputWidth}>
                  <FormControl
                    type="text"
                    value={this.props.serviceReference}
                    onChange={this.handleServiceReferenceChanged}
                  />
                </Col>
              </FormGroup>
              <FormGroup controlId="accountNumber">
                <Col componentClass={ControlLabel} sm={labelWidth}>
                  Account Number
                </Col>
                <Col sm={inputWidth}>
                  <FormControl
                    type="text"
                    value={this.props.accountNumber}
                    onChange={this.handleAccountNumberChanged}
                  />
                </Col>
              </FormGroup>
              <FormGroup controlId="address">
                <Col componentClass={ControlLabel} sm={labelWidth}>
                  Address
                </Col>
                <Col sm={inputWidth}>
                  <FormControl
                    type="text"
                    value={this.props.address}
                    onChange={this.handleAddressChanged}
                  />
                </Col>
              </FormGroup>
              <FormGroup controlId="cityState">
                <Col componentClass={ControlLabel} sm={labelWidth}>
                  City, State
                </Col>
                <Col sm={inputWidth}>
                  <FormControl
                    type="text"
                    value={this.props.cityState}
                    onChange={this.handleCityStateChanged}
                  />
                </Col>
              </FormGroup>
              <FormGroup>
                <Col smOffset={labelWidth} sm={inputWidth}>
                  <Button
                    className="button-right button-top"
                    bsStyle="success"
                    bsSize="small"
                    type="submit"
                    onClick={this.handleSave}
                  >
                    Save
                  </Button>
                  <Button
                    className="button-top"
                    bsStyle="danger"
                    bsSize="small"
                    onClick={this.handleCancel}
                  >
                    Cancel
                  </Button>
                </Col>
              </FormGroup>
            </Form>
          </fieldset>
        </div>
      </div>
    );
  }

  private handleAccountHolderChanged(e: any): void {
    this.props.handleAccountHolderChanged(e.currentTarget.value);
  }
  private handleAccountNumberChanged(e: any): void {
    this.props.handleAccountNumberChanged(e.currentTarget.value);
  }
  private handleAddressChanged(e: any): void {
    this.props.handleAddressChanged(e.currentTarget.value);
  }
  private handleCityStateChanged(e: any): void {
    this.props.handleCityStateChanged(e.currentTarget.value);
  }
  private handleNameKeyChanged(e: any): void {
    this.props.handleNameKeyChanged(e.currentTarget.value);
  }
  private handleServiceReferenceChanged(e: any): void {
    this.props.handleServiceReferenceChanged(e.currentTarget.value);
  }
  private handleSave(e: any) {
    e.preventDefault();
    this.props.handleSave();
  }
  private handleCancel(e: any) {
    e.preventDefault();
    this.props.handleCancel();
  }
}



// WEBPACK FOOTER //
// ./src/components/projects/project/accounts/AccountForm.tsx